import classNames from 'classnames'
import { DotProps } from 'react-multi-carousel'
import React from 'react'

type DotPropsExtension = DotProps & {
  dotMode: 'full-width' | 'right'
  colorTheme: string
  dotClass?: string
}

export const CustomDot = ({
  onClick,
  active,
  dotMode = 'full-width',
  colorTheme = 'gray',
  dotClass = '',
}: DotPropsExtension) => {
  // onMove means if dragging or swiping in progress.
  // active is provided by this lib for checking if the item is active or not.
  return (
    <li
      className={classNames(`custom-dot ${dotClass}`, {
        active: active,
        'u-bg-gray-07': active && colorTheme === 'gray',
        'u-bg-black': active && colorTheme === 'gray' && dotMode === 'right',
        'u-bg-purple': active && colorTheme === 'purple',
        'u-bg-blue': active && colorTheme === 'blue',
        'u-bg-green': active && colorTheme === 'green',
        inactive: !active,
        'custom-dot__full-width': dotMode === 'full-width',
        'custom-dot__right': dotMode === 'right',
      })}
      onClick={() => onClick && onClick()}></li>
  )
}
